// @ts-nocheck
/* eslint-disable */
export const asChevronVerticalIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 15L12 20L17 15M7 9L12 4L17 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'chevron-vertical' as const
};